import PropTypes from 'prop-types';
import React from 'react';
import { isEmpty } from 'lodash';
import HoursOfOperationDay from "./HoursOfOperationDay";
var HoursOfOperationWeek = function HoursOfOperationWeek(_ref) {
  var hours = _ref.hours,
    week = _ref.week;
  var days = week.map(function (day) {
    return /*#__PURE__*/React.createElement(HoursOfOperationDay, {
      key: day,
      day: day,
      hours: hours
    });
  });
  return /*#__PURE__*/React.createElement("div", {
    className: "hours-of-operation-week"
  }, !isEmpty(hours) && days);
};
HoursOfOperationWeek.propTypes = {
  hours: PropTypes.array,
  week: PropTypes.array
};
HoursOfOperationWeek.defaultProps = {
  hours: [],
  week: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday']
};
export default HoursOfOperationWeek;